import React from 'react';
import Banner from '../Banner/Banner';
import Navbar from '../Navbar/Navbar';

const Header = () => {
    return (
        <>
          <Navbar />
          <Banner />  
        </>
    );
};

export default Header;